import React, { useState } from 'react';
import LoginForm from './components/LoginForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import Icon from '../../components/AppIcon';
import { useTranslation } from 'react-i18next';
import SignUpForm from './components/SignUpForm';

const AuthenticationLogin = () => {
  const { t } = useTranslation();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);

  const token = localStorage.getItem('authToken');

  if (token) {
    window.location.href = '/chapter-overview-dashboard';
  }

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-primary/5 via-background to-secondary/5 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary">
              <Icon name="GraduationCap" size={24} className="text-white" />
            </div>
            <h1 className="ml-3 text-2xl font-bold text-gray-900">{t("AI Learning Hub")}</h1>
          </div>

          {!showForgotPassword && (
            <div>
              <h2 className="mb-2 text-2xl font-bold text-gray-900">Welcome Back</h2>
              <p className="text-sm text-gray-600">
                Sign in to continue your learning journey
              </p>
            </div>
          )}
        </div>

        {/* Authentication Card */}
        <div className="p-8 bg-white border border-gray-100 shadow-lg rounded-xl">
          {showForgotPassword ? (
            <ForgotPasswordForm onBackToLogin={() => setShowForgotPassword(false)} />
          ) : showSignUp ? (
            <SignUpForm onBackToLogin={() => setShowSignUp(false)} />
          ) : (
            <LoginForm onForgotPassword={() => setShowForgotPassword(true)} onSignUp={() => setShowSignUp(true)} />
          )}
        </div>

        {/* Footer */}
        <div className="space-y-4 text-center">
          <div className="flex items-center justify-center space-x-2 text-xs text-gray-500">
            <Icon name="Shield" size={14} />
            <span>Secured with SSL encryption</span>
          </div>

          <div className="text-xs text-gray-400">
            <span>By signing in, you agree to our </span>
            <a href="#" className="text-primary hover:text-primary/80">Terms of Service</a>
            <span> and </span>
            <a href="#" className="text-primary hover:text-primary/80">Privacy Policy</a>
          </div>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="fixed inset-0 overflow-hidden -z-10">
        <div className="absolute rounded-full -top-40 -right-32 w-80 h-80 bg-primary/10 blur-3xl"></div>
        <div className="absolute rounded-full -bottom-40 -left-32 w-80 h-80 bg-secondary/10 blur-3xl"></div>
      </div>
    </div>
  );
};

export default AuthenticationLogin;